import {SetStateAction, Dispatch, memo} from 'react';
import {Button, TextField, Typography, Box} from '@mui/material';
// Imported directly (not via the `components` barrel) so this component
// doesn't drag in every other top-level component -- some of which (e.g.
// oAuth's react-speech-recognition) break Jest's environment when pulled in
// transitively (missing regeneratorRuntime).
import {ReusableModalWindow} from 'components/modal';

import styles from '../reportUser/styles.module.scss';
import {
    useReportRoomParticipantLogic,
    ReportRoomParticipantTarget,
} from './localLogix/useReportRoomParticipantLogic';

export const ReportRoomParticipant = memo(
    ({
        open,
        setOpen,
        target,
    }: {
        open: boolean;
        setOpen: Dispatch<SetStateAction<boolean>>;
        target: ReportRoomParticipantTarget | undefined;
    }) => {
        const {reportBody, setReportBody, submitReport, submitting, t} =
            useReportRoomParticipantLogic({setOpen, target});

        return (
            <ReusableModalWindow
                open={open}
                setOpen={setOpen}
                disableEscapeKeyDown={true}
                height={500}
                alignItems="flex-start">
                <Box sx={{position: 'relative', height: '100%'}}>
                    <Typography className={styles.title} variant="h1" component="h2">
                        {t('afterSession.reportAndBlock')} {target?.first_name}{' '}
                        {target?.last_name}
                    </Typography>
                    <br />
                    <Typography className={styles.subTitle} variant="h1" component="h2">
                        {t('afterSession.weHaveZeroTolerance')}
                    </Typography>
                    <br />
                    <TextField
                        id="report-room-participant-subject"
                        label={t('afterSession.subject')}
                        inputProps={{className: styles.subjectInput}}
                        variant="standard"
                        value={reportBody.subject}
                        onChange={(event: any) =>
                            setReportBody(prev => ({
                                ...prev,
                                subject: event.target.value,
                            }))
                        }
                        sx={{width: '100%'}}
                    />
                    <br />
                    <br />
                    <TextField
                        id="report-room-participant-behavior"
                        label={t('afterSession.pleaseDetailExperience')}
                        variant="standard"
                        multiline
                        rows={4}
                        maxRows={4}
                        value={reportBody.info}
                        onChange={(event: any) =>
                            setReportBody(prev => ({
                                ...prev,
                                info: event.target.value,
                            }))
                        }
                        inputProps={{className: styles.subjectInput}}
                        sx={{width: '100%'}}
                    />
                    <Box sx={{position: 'absolute', width: '100%', bottom: 0}}>
                        <Button
                            onClick={submitReport}
                            disabled={submitting}
                            className={styles.reportButton}
                            variant={'contained'}>
                            {t('afterSession.report')} {target?.first_name}{' '}
                            {target?.last_name}
                        </Button>
                    </Box>
                </Box>
            </ReusableModalWindow>
        );
    },
);
